export default {
  'measurement.tons': '{weight} tấn',
  'measurement.height': 'cao',
  'measurement.length': 'dài',
  'measurement.width': 'rộng',
};
